export const LAST_UPDATE_ADD_STORES_INFO = 'last_update_add_stores_info';
export const ADDITIONAL_STORES_INFO = 'additional_stores_info';
export const ALEATORY_DAY_IN_PAST = 'Jan 01 2020';
